export function ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/ag-charts-community/dist/es6/util/compare.js
// module id = 1177
// module chunks = 0